import { isTruthy } from '../../utils'
import type { AdditionalVariableHandler } from '../types'

export const getVariablesForJourneyContext: AdditionalVariableHandler['getVariables'] =
  ({ journey }) => ({
    isAccessedByIndex: false,
    properties:
      journey.contextSchema
        ?.map((contextItem) => contextItem.paramKey)
        .filter(isTruthy) ?? []
  })

export const getValuesForJourneyContext: AdditionalVariableHandler['getValues'] =
  ({ context }) => context._contextParams ?? {}
